import type { FC, PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { nhAppMainPages } from '@pflegenavi/frontend/routing';
import * as Sentry from '@sentry/react';
import { SomethingWentWrong, AppUpdated } from '@pflegenavi/web-components';

const isChunkLoadError = (error: unknown): boolean => {
  if (!(error instanceof Error)) {
    return false;
  }
  return (
    error.message.includes('dynamically imported module') ||
    error.message.includes('Loading chunk') ||
    error.name === 'ChunkLoadError'
  );
};

const ErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const navigate = useNavigate();

  return (
    <Sentry.ErrorBoundary
      fallback={({ resetError, error }) => {
        if (isChunkLoadError(error)) {
          return <AppUpdated />;
        }

        return (
          <SomethingWentWrong
            handleGoHomeClick={() => {
              resetError();
              navigate(nhAppMainPages.HOME);
            }}
            supportEmail="support@pflegenavi.at"
            errorMessage={
              error instanceof Error ? error?.message : JSON.stringify(error)
            }
          />
        );
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
};

export default ErrorBoundary;
